export default "__VITE_ASSET__919a231f__"